/* Combínalos · 10% extra — Tree House Deco
   Sugiere sets (colecciones SET####) en el carrito lateral y en la página del carrito,
   y maneja los botones "Sumar el set" de la sección Combínalos de la ficha. */
(function () {
  if (window.__cmbUpsell) return;
  window.__cmbUpsell = true;

  var TXT = window.CMB_TEXTO || 'Combinalo y obtené un 10% extra';
  var DATA = null, DATA_P = null;

  var css = '' +
    '.cmb-up{margin:1.2rem 0 1.4rem;padding:1.2rem;border-radius:.8rem;background:#f6f1ea;color:#2b2b2b}' +
    '.cmb-up__t{font-weight:700;font-size:1.5rem;margin:0 0 .3rem;display:flex;gap:.6rem;align-items:center}' +
    '.cmb-up__b{display:inline-block;background:#2b2b2b;color:#fff;border-radius:99px;padding:.15rem .7rem;font-size:1.2rem}' +
    '.cmb-up__s{font-size:1.25rem;opacity:.75;margin:0 0 1rem}' +
    '.cmb-up__l{display:grid;grid-auto-flow:column;grid-auto-columns:minmax(130px,1fr);gap:.8rem;overflow-x:auto;padding-bottom:.4rem}' +
    '.cmb-up__c{background:#fff;border-radius:.6rem;overflow:hidden;display:flex;flex-direction:column}' +
    '.cmb-up__c img{width:100%;aspect-ratio:1/1;object-fit:cover;display:block}' +
    '.cmb-up__c span{font-size:1.2rem;padding:.5rem .6rem 0}' +
    '.cmb-up__btn,.cmb-add{cursor:pointer;border:0;background:#2b2b2b;color:#fff;border-radius:.5rem;font-size:1.2rem;padding:.6rem .5rem;margin:.5rem .6rem .6rem;line-height:1.2}' +
    '.cmb-up__btn[disabled],.cmb-add[disabled]{opacity:.55;cursor:default}' +
    '.cmb-up--ok{background:#eef5ec;font-weight:600;font-size:1.35rem}' +
    '.cmb-promo{display:inline-block;background:#2b2b2b;color:#fff;border-radius:99px;padding:.35rem 1rem;font-size:1.3rem;font-weight:600;margin:0 0 1.2rem}' +
    '.cmb-add{display:block;width:calc(100% - 1.2rem)}';
  var st = document.createElement('style'); st.textContent = css; document.head.appendChild(st);

  function upcartRoot() {
    var h = document.getElementById('upCart');
    var r = h && h.shadowRoot;
    if (r && !r.getElementById('cmb-css')) { var x = document.createElement('style'); x.id = 'cmb-css'; x.textContent = css + '.cmb-up{margin:.4rem 1.2rem 1rem;font-size:10px}'; r.appendChild(x); }
    return r;
  }
  function datos() {
    if (DATA) return Promise.resolve(DATA);
    if (!DATA_P) DATA_P = fetch(window.CMB_SETS_URL + '&h=' + Math.floor(Date.now() / 3600000)).then(function (r) { return r.json(); }).then(function (j) {
      var by = {};
      j.s.forEach(function (s) { for (var i = 1; i < s.length; i++) (by[s[i]] = by[s[i]] || []).push(s); });
      DATA = { h: j.h, idx: {}, by: by };
      j.h.forEach(function (h, i) { DATA.idx[h] = i; });
      return DATA;
    });
    return DATA_P;
  }
  function cod(n) { return 'SET' + n; }
  function img(n) { var f = DATA && DATA.im && DATA.im[n]; if (f && f.indexOf('files/') === 0) return '/cdn/shop/' + f + '?width=300'; return '/cdn/shop/collections/' + (f || cod(n) + '.jpg') + '?width=300'; }
  function esCuadro(it) { return !/^set-/.test(it.handle) && !/^set\b/i.test(it.product_title || ''); }

  /* elige la variante del otro cuadro que coincide con la medida/opciones del que ya eligió */
  function variante(p, ref) {
    var vs = p.variants.filter(function (v) { return v.available; });
    if (!vs.length) return null;
    if (ref && ref.length) {
      var m = vs.filter(function (v) { return ref.every(function (o, i) { return v.options[i] === o; }); })[0];
      if (m) return m;
      m = vs.filter(function (v) { return v.options[0] === ref[0]; })[0];
      if (m) return m;
    }
    return vs[0];
  }
  function sumar(handles, ref) {
    return Promise.all(handles.map(function (h) {
      return fetch('/products/' + h + '.js').then(function (r) { return r.ok ? r.json() : null; }).catch(function () { return null; });
    })).then(function (ps) {
      var items = ps.map(function (p) { var v = p && variante(p, ref); return v ? { id: v.id, quantity: 1, properties: { _origen: 'Combínalos' } } : null; }).filter(Boolean);
      if (!items.length) throw new Error('sin stock');
      var drawer = document.querySelector('cart-drawer');
      var body = { items: items };
      if (drawer && !window.upcartRefreshCart && !/\/cart\/?$/.test(location.pathname)) body.sections = 'cart-drawer,cart-icon-bubble';
      return fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify(body) })
        .then(function (r) { return r.json(); }).then(function (res) {
          if (res.status) throw new Error(res.description || 'error');
          if (window.upcartRefreshCart) { try { window.upcartRefreshCart(); } catch (e) {} setTimeout(pintar, 600); }
          else if (body.sections && drawer && drawer.renderContents) { drawer.renderContents(res); }
          else location.reload();
        });
    });
  }

  function bloque(cart) {
    return datos().then(function (D) {
      var its = cart.items.filter(esCuadro);
      var n = its.reduce(function (a, it) { return a + it.quantity; }, 0);
      if (!n) return null;
      var enCarro = {}; cart.items.forEach(function (it) { enCarro[it.handle] = 1; });
      if (n >= 3) {
        var ok = document.createElement('div'); ok.className = 'cmb-up cmb-up--ok';
        ok.textContent = '¡Listo! Ya tenés tu 10% extra aplicado.'; return ok;
      }
      var titulo = n === 2 ? '¡Ya tenés tu 10% extra! Sumá un 3.º y también lleva 10%' : TXT;
      var vistos = {}, cands = [];
      its.slice().reverse().forEach(function (it) {
        var i = D.idx[it.handle]; if (i === undefined) return;
        (D.by[i] || []).forEach(function (s) {
          if (vistos[s[0]]) return; vistos[s[0]] = 1;
          var faltan = s.slice(1).map(function (k) { return D.h[k]; }).filter(function (h) { return !enCarro[h]; });
          if (faltan.length) cands.push({ n: s[0], tot: s.length - 1, faltan: faltan, ref: it.options_with_values ? it.options_with_values.map(function (o) { return o.value; }) : null });
        });
      });
      if (!cands.length) return null;
      cands.sort(function (a, b) { return a.faltan.length - b.faltan.length || a.tot - b.tot; });
      cands = cands.slice(0, 3);
      var el = document.createElement('div'); el.className = 'cmb-up'; el.__cands = cands;
      el.innerHTML = '<p class="cmb-up__t">' + titulo + ' <span class="cmb-up__b">-10%</span></p>' +
        '<p class="cmb-up__s">Estos sets incluyen el cuadro que elegiste. Sumá los que faltan en la misma medida.</p>' +
        '<div class="cmb-up__l"></div>';
      var l = el.querySelector('.cmb-up__l');
      cands.forEach(function (c) {
        var d = document.createElement('div'); d.className = 'cmb-up__c';
        d.innerHTML = '<a href="/collections/' + cod(c.n).toLowerCase() + '"><img loading="lazy" src="' + img(c.n) + '" alt="Set de ' + c.tot + ' cuadros"></a>' +
          '<span>Set de ' + c.tot + ' cuadros</span>';
        var b = document.createElement('button'); b.type = 'button'; b.className = 'cmb-up__btn';
        b.textContent = c.faltan.length === 1 ? 'Sumar el que falta' : 'Sumar los ' + c.faltan.length + ' que faltan';
        b.addEventListener('click', function () {
          b.disabled = true; b.textContent = 'Sumando…';
          sumar(c.faltan, c.ref).catch(function () { b.disabled = false; b.textContent = 'No se pudo, probá de nuevo'; });
        });
        d.appendChild(b); l.appendChild(d);
      });
      return el;
    });
  }

  var pintando = false;
  function pintar() {
    if (pintando) return; pintando = true;
    fetch('/cart.js').then(function (r) { return r.json(); }).then(bloque).then(function (el) {
      document.querySelectorAll('.cmb-up').forEach(function (x) { x.remove(); });
      var up = upcartRoot();
      if (up) up.querySelectorAll('.cmb-up').forEach(function (x) { x.remove(); });
      if (!el) return;
      if (up) {
        var lista = up.querySelector('.upcart-internal-cart-items, .upcart-public-cart-items');
        if (lista) {
          var e3 = el.cloneNode(true);
          e3.querySelectorAll('.cmb-up__btn').forEach(function (b, i) { b.onclick = function () { b.disabled = true; b.textContent = 'Sumando…'; el.__cands[i] && sumar(el.__cands[i].faltan, el.__cands[i].ref).catch(function () { b.disabled = false; b.textContent = 'No se pudo, probá de nuevo'; }); }; });
          lista.parentNode.insertBefore(e3, lista.nextSibling);
        }
      }
      var dr = document.querySelector('#CartDrawer .drawer__footer');
      if (dr) dr.parentNode.insertBefore(el, dr);
      var pg = document.querySelector('#main-cart-footer, .cart__footer');
      if (pg && /\/cart\/?$/.test(location.pathname)) {
        var el2 = dr ? el.cloneNode(true) : el;
        if (dr) el2.querySelectorAll('.cmb-up__btn').forEach(function (b, i) { b.onclick = function () { el.querySelectorAll('.cmb-up__btn')[i].click(); }; });
        pg.parentNode.insertBefore(el2, pg);
      }
    }).catch(function () {}).then(function () { setTimeout(function () { pintando = false; }, 300); });
  }

  /* Ficha: botones "Sumar el set" de la sección Combínalos */
  document.addEventListener('click', function (e) {
    var b = e.target.closest && e.target.closest('.cmb-add'); if (!b) return;
    e.preventDefault();
    var hs = (b.getAttribute('data-handles') || '').split(',').filter(Boolean);
    var form = document.querySelector('form[action*="/cart/add"] [name="id"]');
    var ref = null;
    try { var sel = document.querySelectorAll('variant-selects select, variant-radios input:checked, variant-selects input:checked'); ref = Array.prototype.map.call(sel, function (x) { return x.value; }); } catch (err) {}
    b.disabled = true; var t = b.textContent; b.textContent = 'Sumando…';
    var extra = [];
    if (form && form.value) extra.push(fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ items: [{ id: +form.value, quantity: 1, properties: { _origen: 'Combínalos' } }] }) }));
    Promise.all(extra).then(function () { return sumar(hs, ref); }).then(function () { b.textContent = '¡Sumado!'; })
      .catch(function () { b.disabled = false; b.textContent = t; });
  });

  function engancharUpcart() {
    var r = upcartRoot(); if (!r || r.__cmb) return !!r; r.__cmb = true;
    ['upcartSubscribeCartOpened', 'upcartSubscribeCartUpdated', 'upcartSubscribeAddedToCart', 'upcartSubscribeItemRemoved'].forEach(function (k) {
      try { if (typeof window[k] === 'function') window[k](function () { setTimeout(pintar, 250); }); } catch (e) {}
    });
    new MutationObserver(function (m) {
      if (pintando) return;
      var mio = m.every(function (x) { var t = x.target; return t.closest && t.closest('.cmb-up'); });
      if (!mio && r.querySelector('.upcart-internal-cart-items') && !r.querySelector('.cmb-up')) setTimeout(pintar, 200);
    }).observe(r, { childList: true, subtree: true });
    return true;
  }
  function init() {
    var tries = 0, iv = setInterval(function () { if (engancharUpcart() || ++tries > 40) clearInterval(iv); }, 500);
    pintar();
    if (window.subscribe && window.PUB_SUB_EVENTS) window.subscribe(PUB_SUB_EVENTS.cartUpdate, function () { setTimeout(pintar, 200); });
    var d = document.querySelector('cart-drawer');
    if (d) new MutationObserver(function (m) {
      if (m.some(function (x) { return !(x.target.closest && x.target.closest('.cmb-up')); }) && !d.querySelector('.cmb-up')) setTimeout(pintar, 150);
    }).observe(d, { childList: true, subtree: true });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();
